<template>
  <div>
    <div v-if="!images">
      No Image
    </div>
    <div v-else>
      <div class="selected__image-container">
        <div class="selected__image" :style="'background-image: url(' + images[this.selected] + ')'"></div>
      </div>
      <ul>
        <li :key="index" v-for="(image, index) in images">
          <div @click="selectImage(index)" :class="{active: selected == index}" :style="'background-image: url(' + image + ')'" class="image"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageSlider",
  props: ['images'],
  data() {
    return {
      selected: 0,
    }
  },
  mounted() {
    // this.images = ['/uploads/229/mt-wpc8_1.png' , '/uploads/229/mt-wpc8_1.png']
  },
  methods: {
    selectImage (index) {
      this.selected = index
    },
  }
}
</script>

<style scoped>

ul {
  padding: 0;
  text-align: left;
  margin: 0;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
}

ul>li{
  background: #f2f2f2;
  list-style: none;
  display: inline-block;
  width: 32%;
}

ul::after {
  content: "";
  flex-basis: 32%;
}

.selected__image {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.selected__image-container {
  background: #f2f2f2;
  width: 100%;
  height: 500px;
}

ul>li .image{
  width: 100%;
  height: 80px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 4px solid #f2f2f2;
  cursor: pointer;
}

.active {
  border: 4px solid #dd291a!important;
}



@media (min-width: 1300px) {
  ul>li {
    width: 23%;
  }
  ul::after {
    flex-basis: 23%;
    content: "";
  }
}

@media (max-width: 750px) {
  ul>li{
    width: 23%;
  }
  ul::after {
    flex-basis: 23%;
    content: "";
  }
}


@media (max-width: 1035px) {
  ul>li{
    width: 30%;
  }
  ul::after {
    flex-basis: 30%;
    content: "";
  }
}

@media (min-width: 1500px) {
  ul>li {
    width: 19%;
  }
  ul::after {
    flex-basis: 19%;
    content: "";
  }
}

</style>